import Vue from "vue";
import User from "@/app/models/User";

export default Vue.extend({
    computed: {
        me: {
            get(): User | null {
                return this.$store.getters['auth/current'];
            },
        },
    },
});